/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import Badge from 'shared/ui/components/Badge.vue';
import BaseControl from 'shared/ui/components/form-components/BaseControl.vue';
import LoaderButton from 'shared/ui/components/form-components/LoaderButton.vue';

const __vue_script__ = {
    name: 'SessionRegistrations',

    components: {
        Badge,
        LoaderButton
    },

    extends: BaseControl,

    props: {
        event: {
            type: Object,
            required: true
        },

        value: {
            type: Boolean,
            default: false
        },

        edit: {
            type: Boolean,
            default: false
        },

        model: {
            type: Object,
            required: true
        },

        options: {
            type: Object,
            default: () => null
        }
    },

    data() {
        return {
            exporting: false,
            ready: false,
            registered: 0,
            awaitingPeople: 0
        };
    },

    computed: {
        isWaitlistEnabled() {
            return this.model.waitlist_enabled;
        }
    },

    watch: {
        value: {
            immediate: true,
            handler() {
                this.loadCurrentStatus();
            }
        }
    },

    methods: {
        async loadCurrentStatus() {
            try {
                if (!this.edit) {
                    return;
                }

                const { registered, waitlist_registered } = await this.$services.appScripts.callAppScript(this.event._id, 'agenda/capacity', { sid: this.model.fp_ext_id });

                this.registered = registered;
                if (this.isWaitlistEnabled) {
                    this.awaitingPeople = waitlist_registered || 0;
                }

            } catch (error) {
                const message = this.$utils.net.parseServerError(error);
                console.error('[SessionRegistrations] Error loading capacity:', message);
            } finally {
                this.ready = true;
            }
        },

        async toggleRegistrationState() {
            const change = !this.value;
            this.$emit('input', change);
            const action = change ? this.$i18n.t('agenda.session.reg_open') : this.$i18n.t('agenda.session.reg_closed');
            this.$emit('save', {
                savedMessage: this.$i18n.t('agenda.session.registration_state_changed', [action])
            });
        },

        async getRegistrationsReport() {
            try {
                if (this.exporting) {
                    return;
                }

                this.exporting = true;
                const { filePath } = await this.$services.appScripts.createJobAndWaitForCompletion(this.event._id, 'agenda/export-registrations', {
                    fpExtId: this.model.fp_ext_id
                }, {
                    name: this.$i18n.t('agenda.session.download_reg_report_title'),
                    fileName: `registrations_report_${this.model.fp_ext_id}.xlsx`,
                }, 5000, 2);

                console.debug('[SessionRegistrations] Export job completed');

                this.$utils.browser.downloadFromUrl(filePath);
            } catch (error) {
                console.error('[SessionRegistrations] Could not start export:', error);

                this.$notify({
                    group: 'flashes',
                    title: this.$i18n.t('general.error_occurred').toString(),
                    text: this.$i18n.t('general.try_later').toString(),
                    type: 'error',
                    duration: 5000
                });
            } finally {
                this.exporting = false;
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.edit)?_c('div',{staticClass:"session-registrations"},[_c('ul',[_c('li',[_c('strong',[_vm._v(_vm._s(_vm.$t('agenda.session.registrations'))+":")]),(_vm.value)?_c('badge',{staticClass:"success"},[_vm._v(_vm._s(_vm.$t('agenda.session.reg_open')))]):_c('badge',[_vm._v(_vm._s(_vm.$t('agenda.session.reg_closed')))])],1),(_vm.ready)?[_c('li',[_c('strong',[_vm._v(_vm._s(_vm.$t('agenda.session.registered'))+":")]),_c('badge',{staticClass:"info"},[_vm._v(_vm._s(_vm.registered))])],1),(_vm.isWaitlistEnabled)?_c('li',[_c('strong',[_vm._v(_vm._s(_vm.$t('agenda.session.waitlisted'))+":")]),_c('badge',{staticClass:"info"},[_vm._v(_vm._s(_vm.awaitingPeople))])],1):_vm._e()]:_vm._e()],2),_c('div',{staticClass:"open-registration"},[_c('button',{staticClass:"btn important",class:{ 'btn-primary': _vm.value, 'btn-success': !_vm.value },attrs:{"type":"button"},on:{"click":function($event){return _vm.toggleRegistrationState()}}},[_vm._v(_vm._s(_vm.value ? _vm.$t('agenda.session.close_registration') : _vm.$t('agenda.session.open_registration')))])]),_c('div',{staticClass:"report"},[_c('loader-button',{staticClass:"btn important",attrs:{"type":"button","status":_vm.exporting},on:{"click":_vm.getRegistrationsReport}},[_vm._v(_vm._s(_vm.$t('agenda.session.download_reg_report')))])],1)]):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "SessionRegistrations.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__